module.exports = __webpack_public_path__ + "img/near.04351559.jpg";